import {
  CustomerDataProps,
  ValidateFormProps
} from "@saleor/createOrderCustomer/views/CreateOrderView";
import { makeStyles } from "@saleor/macaw-ui";
import { FormikProps } from "formik";
import React, { createContext, FC, memo, useEffect } from "react";

import CustomerData from "./CustomerData";

export const CustomerContext = createContext(null);

interface CustomerFormikValue {
  shipTo: string;
  billTo: string;
  unloadingPoint: string;
  internalCommentsToWarehouse: string;
  internalCommentsToLogistic: string;
  orderNo: string;
  orderDate: Date;
  requestDeliveryDate: Date;
  remarkForLogistic: string;
}
interface CustomerInfoProps {
  customerData: CustomerDataProps;
  submitForm: (data) => void;
  handleGetCustomerInfo: (values: any) => void;
  validateForm: ValidateFormProps;
  setValidateForm: (values: ValidateFormProps) => void;
  customerFormik: FormikProps<CustomerFormikValue>;
}

const CustomerInfo: FC<CustomerInfoProps> = ({
  customerData,
  handleGetCustomerInfo,
  validateForm,
  setValidateForm,
  customerFormik: formik
}) => {
  const useStyles = makeStyles(
    () => ({
      root: {
        borderRadius: 6,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
        overflow: "hidden",
        marginTop: "1.6rem",
        height: "fit-content"
      }
    }),
    { name: "CreateOrder" }
  );

  const classes = useStyles();

  useEffect(() => {
    if (customerData) {
      const address1 =
        customerData?.customerInfo?.addresses?.[0]?.streetAddress1;
      const address2 =
        customerData?.customerInfo?.addresses?.[0]?.streetAddress2;
      const addressStr = Object.values({
        address1,
        address2
      })
        .filter(i => Boolean(i))
        .join(", ");

      formik.setValues({
        orderNo: customerData?.orderNo || "",
        orderDate: customerData?.orderDate || new Date().toDateString(),
        requestDeliveryDate: customerData?.requestDeliveryDate,
        shipTo: customerData?.shipTo || addressStr,
        billTo: customerData?.billTo || addressStr,
        unloadingPoint: customerData?.unloadingPoint || addressStr,
        internalCommentsToWarehouse:
          customerData?.internalCommentsToWarehouse || "",
        internalCommentsToLogistic:
          customerData?.internalCommentsToLogistic || "",
        remarkForLogistic: customerData?.remarkForLogistic || ""
      });
    }
  }, [JSON.stringify(customerData)]);

  useEffect(() => {
    handleGetCustomerInfo(formik.values);
  }, [formik.values]);

  useEffect(() => {
    // if (validateForm?.isCheckValidate && !formik.isValid) {
    //   // formik.handleSubmit();
    // }

    setValidateForm({
      ...validateForm,
      isValidate: {
        ...validateForm?.isValidate,
        validateInfo: formik.isValid
      }
    });
  }, [validateForm?.isCheckValidate, formik.isValid]);

  return (
    <div className={classes.root}>
      <CustomerContext.Provider value={{ customerData, formik }}>
        <form onSubmit={formik.handleSubmit}>
          <CustomerData />
        </form>
      </CustomerContext.Provider>
    </div>
  );
};

export default memo(CustomerInfo);
